export default __webpack_public_path__ + "static/media/p84.2f7e34f8.jpg";